import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { isAfter, isSameDay } from 'date-fns';
import { includes, keys } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import Locked from '@gef-ui/components/atoms/SvgIcon/Icons/Locked';
import Unlocked from '@gef-ui/components/atoms/SvgIcon/Icons/Unlocked';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { toIsoDateFormat } from 'utils';

export const getUnlockStatusIcon = (extendedDateTo, unlockDateTo) => {
	const date = isNilOrEmpty(extendedDateTo) ? new Date(unlockDateTo) : new Date(extendedDateTo);
	const today = new Date();
	const icon = {};

	if (isSameDay(date, today)) {
		icon.component = Unlocked;
		icon.color = 'warning.main';
		icon.text = getLabelMessage('unlockedClients:unlockedForDayClient');
	} else if (isAfter(date, today)) {
		icon.component = Unlocked;
		icon.color = 'success.main';
		icon.text = getLabelMessage('unlockedClients:fullyUnlockedClient');
	} else {
		icon.component = Locked;
		icon.color = 'common.black';
		icon.text = getLabelMessage('unlockedClients:lockedClient');
	}

	const { component: FinalIcon, color, text } = icon;
	return (
		<Tooltip title={text}>
			<IconButton disableRipple size="small" sx={{ color }}>
				<FinalIcon />
			</IconButton>
		</Tooltip>
	);
};

export const requestBodyFactory = (formData) => {
	let finalObject = {};

	keys(formData).forEach((key) => {
		const value = formData[key];

		const isDateInput = includes(key, ['extendedFrom', 'extendedTo', 'unlockedFrom', 'unlockedTo', 'birthDate']);
		if (isDateInput) {
			finalObject = {
				...finalObject,
				[key]: toIsoDateFormat(value),
			};
		} else {
			finalObject = {
				...finalObject,
				[key]: value,
			};
		}
	});
	return finalObject;
};
